<template>
    <pm-app-component hide-sidebar>
        <template slot="mobile-toolbar">
            <pm-application-bar hide-by>
                <span @click="onVersionClick">DentiCalc</span>&nbsp;
                <sup style=" color:#2eafe8; display: none"> 4in1</sup>
                <!-- <span style="font-size: 13px; color: #ddd;" v-if="!IAP.hasAccessToComponent('premium')"> {{$t('iap.basic')}}</span> -->
                <!-- <span style="font-size: 13px; color: #ddd;" v-if="IAP.hasSubscriptionToComponent('premium')" class="subtitle--premium"> {{$t('iap.premium')}}
                    <span @click="$bus.$emit('openAppDialog','premium', {'title': '', 'referrer': 'click_app_bar'})" v-if="!IAP.hasSubscriptionToComponent('premium')">({{$t('iap.n-days-left', {n: trialDaysLeft})}})</span>
                </span> -->
            </pm-application-bar>
        </template>

        <div id="pm-dashboard">
            <div id="pm-dashboard-main">
                <pm-bright-plans-banner />
                
                <div style="margin: 16px 0 0 0; font-weight: 900; font-style: italic; font-size: 26px;">4 dental apps in 1</div>

                

                 <div id="pm-dashboard-menu-grid" :key="IAP.status.length">
                    <template v-for="(item, i) in items">
                        <pm-dashboard-button-primary
                            v-if="item.visible()"
                            :key="item.link"
                            :item="item"
                            :class="!showSettings ? 'pm-animation-fade-in-scale' : ''"
                            :style="'--delay: '+i * 40+'ms'"
                        />
                    </template>
                </div>

                <!-- <pm-dashboard-smart /> -->
                <div style="border-top: 1px solid #ddd; margin-top: 20px;" />
                <!-- <div style="position: relative; z-index: 1; padding: 16px 0 0px 16px; font-size: min(3.2vw, 15px); font-weight: 600; letter-spacing: 1px; text-align: left;">ADDITIONAL TOOLS & SETTINGS</div> -->
                <div id="pm-dashboard-menu-grid-settings" style="padding: 20px 20px 20px 20px;">
                    <pm-dashboard-button-secondary v-for="(item, i) in itemsSettings" :key="item.link" :item="item" />
                </div>
            </div>
        </div>

        <pm-debug-dialog v-if="showFlutterEventLog" @close="showFlutterEventLog = false" />
        <!-- <pm-welcome-screen v-if="onboarding.length > 0" :steps="onboarding" /> -->
    </pm-app-component>
</template>

<style>
#main-scrollable-content {
    background: #f1f1f1;
}
#pm-dashboard {
    padding: 0 0 10px 0;
    background: #f1f1f1;
    background-size: cover;
    background-attachment: fixed;
    background-position: center center;
    min-height: auto;
    text-align: center;
}

#pm-dashboard-main {
    position: relative;
}


#pm-dashboard-menu-grid {
    padding: 16px 16px 6px 14px;
    font-size: 16px;
    text-align: center;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-column-gap: 24px;
    grid-row-gap: 24px;
}

#pm-dashboard-menu-grid-settings {
    padding: 30px 20px;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-column-gap: 16px;
    grid-row-gap: 16px;
}

::-webkit-scrollbar {
    width: 0px;
}
</style>

<script>
import PmAppComponent from "../core/pm-app-component";
import ToolbarMixin from "../../extensions/mixins/mixin-toolbar";
import PmDashboardButtonPrimary from "./dashboard-button-primary";
import PmDashboardButtonSecondary from "./dashboard-button-secondary";
import FlutterMountedMixin from "@/extensions/mixins/mixin-flutter-mounted";
import PmDebugDialog from "../debug/debug-dialog";
// import PmDashboardSmart from "./dashboard-smart.vue";
import itemsSettings from "./items-settings";
import { trialDaysLeft } from "@/utils/iap/trial-days";
import { isDev } from "../../utils/debug/is-dev";
// import { onboarding } from "./onboarding.js";
import { logReviewRequested, isReviewDue } from "@/utils/user/review";
import { countUnreadMessages } from "../../configs/in-app-messages";
import { initChat } from "../../utils/chat/index";
import { shouldShowOffer } from "@/utils/promo-offer";
import { checkVersion } from "@/utils/force-update";
import items from "./items";
import PmBrightPlansBanner from "./brightplans-banner.vue";

export default {
    name: "PmAppDashboard",
    components: {
        PmAppComponent,
        PmDashboardButtonPrimary,
        PmDashboardButtonSecondary,
        PmDebugDialog,
        // PmDashboardSmart,
        PmBrightPlansBanner,
    },
    mixins: [
        ToolbarMixin,
        FlutterMountedMixin,
    ],
    data: () => ({
        items: items(),
        itemsSettings: itemsSettings(),
        subscribed: false,
        nextRoute: "/",
        nextRouteTitle: "",
        showFlutterEventLog: false,
        flutterEventLog: window.flutterEventLog,
        flutterVersion: 0,
        IAP: window.IAP,
        versionClickCounter: 0,
        appVersion: window.appVersion,
        trialUsed: false,
        trialDaysLeft: trialDaysLeft(),
    }),
    toolbar() {
        const items = [];


        // items.push({
        //     text: app.$t("menu.support"),
        //     icon: "help",
        //     // mdi: "mdiForumOutline",
        //     callback: () => {
        //         this.$router.push("/support");
        //     },
        // });

        //  items.push({
        //      mdi: "starOutline",
        //      text: this.$t('support.rate_us'),
        //      callback: () => {
        //          if(isDev) this.$bus.$emit('openAppDialog','videoDialog');
        //          else this.$bus.$emit('openAppDialog','review');
        //      },
        //  });

        items.push({
            mdi: "mdiEmailOutline",
            text: "Messages",
            callback: () => {
                this.$router.push("/messages");
            },
            badge: () => {
                const count = countUnreadMessages();
                return count > 0 ? count : null;
            }
        });

        items.push({
             placeholder: true,
        });

        items.push({
             placeholder: true,
        });

        /* items.push({
            mdi: "mdiForumOutline",
            //text: this.$t('support.chat_with_us'),
            text: "Chat with us",
            callback: () => {
                initChat();
            },
        }); */

        // items.push({
        //     placeholder: true,
        // });


        // if (
        //     isDev ||
        //     (
        //         trialDaysLeft() <= 1 &&
        //         window.IAP.status.includes('offeringsLoaded') &&
        //         !window.IAP.hasSubscriptionToComponent('premium') &&
        //         !localStorage.getItem('extendedTrial')
        //     )
        // ) {
        //     items.push({
        //         mdi: "mdiGiftOutline",
        //         text: this.$t('iap.special-offer-menu'),
        //         callback: () => {
        //             app.$bus.$emit('video-review-offer:show');
        //             localStorage.setItem("videoReviewSpecialOfferViewed", "1");
        //             this.updateToolbar();
        //         },
        //         badge: () => {
        //             return localStorage.getItem("videoReviewSpecialOfferViewed") ? null : "!";
        //         }
        //     });
        // } else {
        //     items.push({
        //         placeholder: true,
        //     });
        // }

        // items.push({
        //     placeholder: true,
        // });

        /* items.push({
            mdi: "mdiHelpCircleOutline",
            text: this.$t('faq.title'),
            callback: () => {
                this.$router.push("/faq");
            },
        }); */

        if (this.nextRoute === "/") {
            items.push({
                placeholder: true,
            });
        } else {
            items.push({
                icon: "chevron_right",
                iconClass: "app-back-button-icon",
                text: this.nextRouteTitle,
                callback: () => {
                    if (this.nextRoute === "/") return;
                    let l = this.$router.resolve({path: this.nextRoute});
                    if (l.resolved.matched.length > 0) {
                        this.$router.push(this.nextRoute);
                    } else {
                        //the route does not exists.
                    }
                },
            });
        }

        return [items];
    },

    created() {
        this.updateToolbar();
        this.registerBusEvent("flutter:onOfferingsUpdated", () => {
            this.$forceUpdate();
            this.updateToolbar();
        });

        this.registerBusEvent("flutter:updateFirstRunTS", () => {
            this.trialDaysLeft = trialDaysLeft();
        });

        // this.onboarding = onboarding();
    },
    async mounted() {
        checkVersion();
        document.getElementById('main-scrollable-content').style.overflowY = 'scroll';
        try {
            this.logDashboardOpened();
            this.$bus.$emit('dashboard:opened');

            let showOffer = false;
            if (!IAP.hasPremiumAccess()) {
                let appDashboardOpenCounter = localStorage.getItem('appDashboardOpenCounter') || 0;
                if (appDashboardOpenCounter % 20 === 0) {
                    // this.$bus.$emit('openAppDialog','premium',{'title': '', 'referrer': 'auto_dashboard_20'});
                    // showOffer = true;
                }
            }

            // let showOffer = shouldShowOffer();
            // if (showOffer) this.$bus.$emit('openAppDialog','winWheel');

            if (!showOffer && isReviewDue()) {
                this.$bus.$emit('openAppDialog','review');
                logReviewRequested();
            }

            if (typeof this.$store.state['app/dashboardScrollPosition'] !== "undefined") {
                const el = document.getElementById("main-scrollable-content");
                el.style.scrollBehavior = "auto";
                el.scrollTo(0, this.$store.state['app/dashboardScrollPosition']);
                el.style.scrollBehavior = "smooth";
            }
        } catch (error) {
            captureException(error);
        }
    },

    beforeRouteEnter(to, from, next) {
        return next((vm) => {
            vm.nextRoute = from.path;

            if (from.path.includes('gallery')) vm.nextRouteTitle = "Photos";
            else if (from.path.includes('animation')) vm.nextRouteTitle = "Videos";
            else if (from.path.includes('calculator')) vm.nextRouteTitle = "Calculator";
            else if (from.path.includes('plan')) vm.nextRouteTitle = "Smart";
            else vm.nextRouteTitle = "";
            vm.updateToolbar();
        });
    },

     beforeRouteLeave(to, from, next) {
        try {
            this.$store.state['app/dashboardScrollPosition'] = document.getElementById("main-scrollable-content").scrollTop;
        } catch (error) {
            captureException(error);
        }
        next();
     },

    methods: {
        logDashboardOpened() {
            let appDashboardOpenCounter = localStorage.getItem('appDashboardOpenCounter') || 0;
            appDashboardOpenCounter = parseInt(appDashboardOpenCounter)+1;
            localStorage.setItem('appDashboardOpenCounter', appDashboardOpenCounter);
        },
        onVersionClick() {
            if (!(isDev || localStorage.getItem('isDevMode') === "true")) return;

            this.versionClickCounter++;

            if (this.versionClickCounter === 1) {
                this.showFlutterEventLog = true;
                this.versionClickCounter = 0;

                /**
                 * First time set to 1 and after toggling it between 0 and 1.
                 */
                if (localStorage.getItem('isTester') === null) {
                    localStorage.setItem('isTester', '1');
                } else {
                    localStorage.setItem('isTester', localStorage.getItem('isTester') === '1' ? '0' : '1');
                }

                const propVal = parseInt(localStorage.getItem('isTester'), 10) || 0;
                const timestamp = Date.now();

                // Add item to the top of stack.
                window.flutterEventLog.unshift({
                    eventName: 'tester',
                    data: JSON.parse(JSON.stringify({ propVal, timestamp })),
                });

                window.Tracker.setUserProperty('tester', propVal, {
                    event_name: 'tester',
                    event_label: 'tester',
                    event_value: propVal,
                });
            }
        },
    },
};
</script>
